var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 23.625V18.375H18.375L14 13.125L9.625 18.375H13.125V23.625H8.75V23.5813C8.603 23.59 8.463 23.625 8.3125 23.625C6.57202 23.625 4.90282 22.9336 3.67211 21.7029C2.4414 20.4722 1.75 18.803 1.75 17.0625C1.75 13.6955 4.29625 10.9515 7.5635 10.5753C7.84996 9.07777 8.64929 7.72691 9.824 6.75501C10.9987 5.78312 12.4754 5.25093 14 5.25C15.5249 5.25084 17.0018 5.78295 18.1768 6.75483C19.3518 7.72671 20.1514 9.07761 20.4382 10.5753C23.7055 10.9515 26.2482 13.6955 26.2482 17.0625C26.2482 18.803 25.5568 20.4722 24.3261 21.7029C23.0954 22.9336 21.4262 23.625 19.6857 23.625C19.5387 23.625 19.397 23.59 19.2482 23.5813V23.625H14.875Z",
    fill: "#699BF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d2aa212dec88c70395131af522876455.svg";
export { ForwardRef as ReactComponent };